import Big from 'big.js'

export const centsToDollars = (amount) => {
  const dollars = parseFloat(Big(amount).round(2).toString())
  return dollars.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
}
